/**
 * 만원 단위 금액을 한국어 표기로 변환
 * e.g., 65000 → "6억 5,000만원", 80000 → "8억"
 */
export function formatKoreanPrice(priceInManwon: number): string {
  if (priceInManwon < 0) return '-' + formatKoreanPrice(-priceInManwon);
  if (priceInManwon === 0) return '0원';

  const eok = Math.floor(priceInManwon / 10000);
  const man = priceInManwon % 10000;

  const parts: string[] = [];
  if (eok > 0) parts.push(`${eok}억`);
  if (man > 0) parts.push(`${man.toLocaleString('ko-KR')}만원`);
  else if (eok > 0) parts.push('');

  return parts.join(' ').trim() || '0원';
}

/**
 * m² → 평 변환 (1평 = 3.305785 m²)
 */
export function sqmToPyeong(sqm: number): number {
  return Math.round((sqm / 3.305785) * 10) / 10;
}

/**
 * 평 → m² 변환
 */
export function pyeongToSqm(pyeong: number): number {
  return Math.round(pyeong * 3.305785 * 10) / 10;
}

/**
 * 면적 표시 (m² + 평)
 * e.g., "84m² (25.4평)"
 */
export function formatArea(sqm: number): string {
  return `${sqm}m² (${sqmToPyeong(sqm)}평)`;
}

/**
 * 날짜 포맷 (YYYY.MM.DD)
 */
export function formatDate(date: string | Date | undefined | null): string {
  if (!date) return '-';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '-';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}.${m}.${day}`;
}

/**
 * 거래일 포맷 (YYYY.MM)
 */
export function formatDealDate(year: number, month: number, day?: number): string {
  const m = String(month).padStart(2, '0');
  if (day) {
    return `${year}.${m}.${String(day).padStart(2, '0')}`;
  }
  return `${year}.${m}`;
}

/**
 * 숫자 콤마 표기
 */
export function formatNumber(num: number): string {
  return num.toLocaleString('ko-KR');
}

/**
 * 퍼센트 표시
 */
export function formatPercent(value: number, decimals = 1): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(decimals)}%`;
}

/**
 * 층수 표시
 */
export function formatFloor(floor: number): string {
  if (floor < 0) return `지하${Math.abs(floor)}층`;
  return `${floor}층`;
}
